  // Carry supersearch input to supersearch page
  $('.super__search_submit').click(function () {
    goToSuperSearch();
    return false;
});

function goToSuperSearch() {
    var string = $('#SuperSearch_SuperSearch').val();
    var url = "https://search.eddiewright.co.uk//#/" + "?s=" + string ;
    window.location.href = url;
}	

// Run function on return
$('#SuperSearch_SuperSearch').keypress(function(event){
  if(event.keyCode == 13){
    goToSuperSearch();
    return false;
  }
});

// Add dynamic text to search box
var typed = new Typed('#SuperSearch_SuperSearch', {
    strings: ["Looking for...?","a Grey BMW 5 Series?","Black Audi A6?","Plus many more?","Start your search..."],
    typeSpeed: 50,
    backSpeed: 0,
    attr: 'placeholder',
    bindInputFocusEvents: true,
    loop: true
});

